<template>
  <div
    class="attention-box"
    :class="width"
  >
    <div class="attention-box__message">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttentionBox',
  props: {
    width: {
      type: String
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/standards";

.attention-box {
  background-color: #dadada;
  display: flex;
  padding: 20px;
  margin: auto;
  transform: translateY(34px) translateX(-34px);
  width: calc(100% + 68px) !important;

  &__message {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #4a4a4a;
    margin: auto;
    width: 100%;
  }
}
</style>
